import * as React from "react";

import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkText } from "uitk-react-text";

interface LobCarDetailsProps {
  carCategory: string;
}

const LobCarDetails = (props: LobCarDetailsProps) => {
  const { carCategory } = props;

  if (!carCategory) {
    return null;
  }

  return (
    <UitkSpacing margin={{ blockstart: "two" }}>
      <UitkLayoutFlex space="one">
        <UitkIcon name="lob_cars" size={UitkIconSize.SMALL} />
        <UitkText size={300} weight="bold" theme="emphasis">
          {carCategory}
        </UitkText>
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};

export default LobCarDetails;
